/**
 * Справочник меток результата разговора.
 *
 * Поведение системы задаётся флагами метки, а не её названием: переименование
 * ничего не ломает, смена флага меняет движение контакта по кругам (§6.6).
 * Пара is_lead + returns_to_queue запрещена в базе CHECK-констрейнтом —
 * лид не может одновременно закрываться и возвращаться в очередь.
 */
import { z } from 'zod';
import { isoDateTimeSchema, refIdSchema } from './common.dto.js';
/** Задержка до следующего круга в минутах: наружу интервал отдаём числом */
const nextRoundDelayMinutesSchema = z.number().int().min(0).max(60 * 24 * 30);
export const labelSchema = z.object({
    id: refIdSchema,
    code: z.string().min(2).max(40),
    title: z.string().min(1).max(120),
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
    isLead: z.boolean(),
    returnsToQueue: z.boolean(),
    isNegative: z.boolean(),
    /** «Навсегда не звонить»: влияет на дедуп приёма, а не только на очередь (§6.8) */
    isTerminal: z.boolean(),
    requiresComment: z.boolean(),
    /** Пульт спрашивает «когда перезвонить?» и шлёт nextActionAt вместе с меткой */
    asksSchedule: z.boolean(),
    nextRoundDelayMinutes: nextRoundDelayMinutesSchema.nullable(),
    sortOrder: z.number().int(),
    isActive: z.boolean(),
    createdAt: isoDateTimeSchema,
});
const labelWriteShape = {
    code: z.string().min(2).max(40).regex(/^[a-z0-9_]+$/, 'только строчные латинские буквы, цифры и подчёркивание'),
    title: z.string().min(1).max(120),
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
    isLead: z.boolean().default(false),
    returnsToQueue: z.boolean().default(false),
    isNegative: z.boolean().default(false),
    isTerminal: z.boolean().default(false),
    requiresComment: z.boolean().default(false),
    asksSchedule: z.boolean().default(false),
    nextRoundDelayMinutes: nextRoundDelayMinutesSchema.nullable().default(null),
    sortOrder: z.number().int().min(0).max(1000).default(0),
    isActive: z.boolean().default(true),
};
export const createLabelBodySchema = z
    .object(labelWriteShape)
    .refine((l) => !(l.isLead && l.returnsToQueue), {
    message: 'лид не возвращается в очередь: выберите одно',
});
/** Код метки не меняется: на него завязаны отчёты и настройки (§5.4) */
export const updateLabelBodySchema = z
    .object(labelWriteShape)
    .omit({ code: true })
    .partial()
    .refine((l) => !(l.isLead === true && l.returnsToQueue === true), {
    message: 'лид не возвращается в очередь: выберите одно',
});
export const labelsResponseSchema = z.object({ items: z.array(labelSchema) });
//# sourceMappingURL=labels.dto.js.map